import React from "react"
import { Card, Col, Input, Row, Table } from "reactstrap"
import { useSelector } from "react-redux"
import ScrollBar from "react-perfect-scrollbar"
import CheckboxType from "pages/Inspection/CheckboxType"
import DropdownType from "pages/Inspection/DropdownType"
import TextInputType from "pages/Inspection/TextInputType"
import RadioType from "pages/Inspection/RadioType"
import "./style.css"

function Jacket(props) {
  const store = useSelector(state => state)
  const jacket = store.inspection.orderSize.data?.jacket

  if (!jacket) return null

  return (
    <Card body>
      <ScrollBar style={{ height: 585, position: "relative" }}>
        <Row>
          <Col md="12">
            <div className="fw-bold">仕様枠</div>
            <Row>
              {jacket.specifications.map((i, k) => (
                <>
                  <Col md={3} key={k} className="border p-2">
                    {i.item}
                  </Col>
                  <Col md={3} className="border p-2">
                    {i.format == "チェックボックス" && (
                      <CheckboxType answers={i.answers} />
                    )}

                    {i.format == "プルダウン" && (
                      <DropdownType answers={i.answers} />
                    )}
                    {i.format == "TEXT" && (
                      <TextInputType answers={i.answers} />
                    )}

                    {i.format == "ラジオボタン" && (
                      <RadioType answers={i.answers} />
                    )}
                  </Col>
                </>
              ))}
            </Row>
          </Col>
        </Row>
        <div style={{ width: 800 }}>
          <Row className="mt-4">
            <Col md="12">
              <div className="fw-bold">寸法</div>
              <div>
                <Table bordered striped>
                  <tbody>
                    {jacket.dimensions.map((i, k) => (
                      <tr key={k}>
                        <td>{i.item}</td>
                        <td>{i.gaugeDimensions}</td>
                        <td>{i.correctionValue}</td>
                        <td>{i.lawToGoUp}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Col>
            <Col md="12" className="my-4">
              <div className="fw-bold">補正</div>
              <Row className="flex-nowrap overflow-auto m-1">
                {jacket.otherDimensions.map((i, k) => (
                  <React.Fragment key={k}>
                    <Col md={3} key={k} className="border p-2">
                      {i.item}
                      <Row>
                        <Col md={12} className="border p-2">
                          {i.format == "チェックボックス" && (
                            <CheckboxType answers={i.answers} />
                          )}

                          {i.format == "プルダウン" && (
                            <DropdownType answers={i.answers} />
                          )}
                          {i.format == "TEXT" && (
                            <Input value={i?.answer || ""} disabled />
                          )}
                          {/* <TextInputType answers={i.answer} /> */}

                          {i.format == "ラジオボタン" && (
                            <RadioType answers={i.answers} />
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </React.Fragment>
                ))}
              </Row>
            </Col>
          </Row>
        </div>
      </ScrollBar>
    </Card>
  )
}

export default Jacket
